<template>
  <button
    type="button"
    class="close-button focus:outline focus:outline-2 focus:outline-offset-1 focus:outline-blue-400 dark:focus:outline-blue-500"
    :class="{ 'button-small': size === 'small', 'button-smaller': size === 'smaller' }"
    :aria-label="ariaLabel"
  >
    <IconClose aria-hidden="true" class="m-0" />
    <ProgressCircle
      v-if="showProgressCircle"
      class="progress-circle"
      :percent="percent"
      :circle-width="circle.width"
      :stroke-width="circle.stroke"
      :animation-duration-millis="progressCircleDurationMillis"
    />
  </button>
</template>

<style lang="scss" scoped>
.close-button {
  border-radius: 50%;
  width: 2.1rem;
  height: 2.1rem;
  display: grid;
  place-items: center;
  transition: all 300ms;
  position: relative;
  border: transparent;
  color: $text-muted;
  background-color: $color-darkened-30;

  &:hover {
    color: $body-color;
    background-color: $color-darkened-150;
  }

  &.button-dark {
    color: $color-lightened-700;
    background-color: $color-darkened-150;
    &:hover {
      color: white;
      background-color: $color-darkened-300;
    }
  }
  &.button-small {
    width: 1.7rem;
    height: 1.7rem;
    svg {
      font-size: 0.8rem;
    }
    .progress-circle {
      top: -2px;
      left: -1px;
    }
  }
  &.button-smaller {
    width: 1.3rem;
    height: 1.3rem;
    svg {
      font-size: 0.6rem;
    }
    .progress-circle {
      top: -1px;
      left: -1px;
    }
  }

  .progress-circle {
    position: absolute;
    top: -2px;
    left: -1px;
  }
}
</style>

<script lang="ts">
import { defineComponent } from 'vue';

import ProgressCircle from '@/components/ProgressCircle.vue';
import IconClose from '~icons/lucide/x';

export default defineComponent({
  name: 'CloseButton',
  components: { ProgressCircle, IconClose },
  props: {
    size: {
      type: String,
      default: '',
    },
    showProgressCircle: {
      type: Boolean,
      default: false,
    },
    progressCircleDurationMillis: {
      type: Number,
      default: 2000,
    },
    ariaLabel: {
      type: String,
      default: 'Close',
    },
  },
  data() {
    return {
      percent: 0,
      progressCircle: { width: 37, stroke: 2 },
      progressCircleSmall: { width: 30, stroke: 1 },
      progressCircleSmaller: { width: 22, stroke: 1 },
    };
  },
  computed: {
    circle() {
      switch (this.size) {
        case 'small':
          return this.progressCircleSmall;
        case 'smaller':
          return this.progressCircleSmaller;
        default:
          return this.progressCircle;
      }
    },
  },
  mounted() {
    if (this.showProgressCircle) {
      setTimeout(() => {
        this.percent = 100;
      }, 100);
    }
  },
});
</script>
